import { render, staticRenderFns } from "./ApprovazioneLoghi.vue?vue&type=template&id=04b52e2b"
import script from "./ApprovazioneLoghi.vue?vue&type=script&lang=js"
export * from "./ApprovazioneLoghi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports